import ConfigurableListPageTemplate from './ConfigurableListPageTemplate'

export default ConfigurableListPageTemplate
